import type { Options } from "focus-trap";
import { createFocusTrap } from "focus-trap";

type FocusTrapParams = {
    readonly enabled: boolean;
    readonly elements?: readonly HTMLElement[];
    readonly options?: Options;
};

type FocusTrapUpdateParams = Omit<FocusTrapParams, "options">;

export type FocusTrapReturnType = {
    update: (params: FocusTrapUpdateParams) => void;
    destroy: () => void;
};

export const focusTrap = (
    target: HTMLElement,
    params: FocusTrapParams
): FocusTrapReturnType => {
    const elements = params.elements ? [target, ...params.elements] : [target];
    const trap = createFocusTrap(elements, params.options);

    if (params.enabled) {
        trap.activate();
    }

    function destroy() {
        trap.deactivate();
    }

    function update(newParams: FocusTrapUpdateParams) {
        const newElements = newParams.elements
            ? [target, ...newParams.elements]
            : [target];
        trap.updateContainerElements(newElements);

        if (newParams.enabled) {
            trap.activate();
        } else {
            trap.deactivate();
        }
    }

    return {
        update,
        destroy,
    };
};
